import {
  ChangeDetectionStrategy,
  Component,
  computed,
  forwardRef,
  input,
  OnInit,
  output,
  Resource,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelViewBase, UiCoreModule } from '@softline/ui-core';
import { RemoteDataPanelViewBase } from '../remote-data-panel-view.base';
import { ResourceContainerComponent } from '../../components/resource-container/resource-container.component';
import { Result } from '@softline/core';
import { isArray } from 'mathjs';

export type ResultArray<T extends Array<any>> = T extends Result<infer R> ? R[] : never;

@Component({
  selector: 'soft-master-detail-panel-view',
  imports: [CommonModule, UiCoreModule, ResourceContainerComponent],
  templateUrl: './master-detail.panel-view.html',
  styleUrl: './master-detail.panel-view.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: PanelViewBase,
      useExisting: forwardRef(() => MasterDetailPanelView),
    },
    {
      provide: RemoteDataPanelViewBase,
      useExisting: forwardRef(() => MasterDetailPanelView),
    },
  ],
})
export class MasterDetailPanelView<T>
  extends RemoteDataPanelViewBase<T[] | Result<T[]> | undefined>
  implements OnInit
{
  override name = input.required<string>();
  override label = input<string>('Tabelle');
  override icon = input<string>('fa-regular fa-table-layout');
  override template = viewChild<TemplateRef<any>>('template');
  override resource = input.required<Resource<T[] | Result<T[]> | undefined>>();

  dataContainerClass = input<string | null>();

  dataContainerStyles = input<Partial<CSSStyleDeclaration> | undefined>(undefined);

  readonly items = computed(() => {
    const value = this.resource().value();
    if (isArray(value)) return value;
    return value?.result;
  });

  selectedData = input<T | null>(null);
  selectionChange = output<T | null>();

  masterTemplate = input<TemplateRef<any> | null>(null);
  detailTemplate = input<TemplateRef<any> | null>(null);

  ngOnInit(): void {
    console.log('MasterDetailPanelView: ', this.dataContainerClass());
  }

  isResult(value: any): value is Result<T[]> {
    return !!value && typeof value === 'object' && !!value?.['result'];
  }
}
